export default __webpack_public_path__ + "static/media/version.080fbcc6.txt";